import { atom, selector } from 'recoil';

export type EmailTag = { type: 'email'; email: string };
export type UserTag = { type: 'user'; displayName: string; user: string };
export type TeamTag = { type: 'team'; title: string; team: string; organization: string };

export type PermissionTag = EmailTag | UserTag | TeamTag;

/**
 * State storing the tags being typed in the input.
 */
export const inviteMembersInputAtom = atom<PermissionTag[]>({
    key: 'inviteMembersInputAtom',
    default: [],
});

/**
 * Selector to know if the input is empty.
 */
export const inviteMembersInputIsEmptySelector = selector({
    key: 'inviteMembersInputIsEmptySelector',
    get: ({ get }) => {
        const input = get(inviteMembersInputAtom);
        return input.length === 0;
    },
});
